module.exports = __webpack_public_path__ + "img/bg-login-page-dark.d9e50e77.svg";